/** @file Dopesheet box select: row range x frame range, each row binary-searched. */
import { readNum } from './_internal/readNum';
import { sortedLowerBound } from './_internal/sortedLowerBound';
import type { TimelineKeyHit } from './hitTimelineKey';
import { normalizeRect } from './normalizeRect';
import type { ScreenRect } from './normalizeRect';
import type { TimelineLayout } from './timelineLayout';
import { timelineRowRange } from './timelineRowRange';
import { timelineScale } from './timelineScale';
import type { TimelineScale } from './timelineScale';

/** Keys of every row the rectangle's y range overlaps whose frame is in its x range (edges inclusive), row then frame. */
export function timelineKeysInBox(layout: TimelineLayout, scale: TimelineScale, rect: ScreenRect): TimelineKeyHit[] {
  const r = normalizeRect(rect);
  const [first, end] = timelineRowRange(layout, r.y0, r.y1);
  const f0 = timelineScale.xToFrame(scale, r.x0);
  const f1 = timelineScale.xToFrame(scale, r.x1);
  const out: TimelineKeyHit[] = [];
  for (let row = first; row < end; row++) {
    const frames = layout.rows[row]?.frames ?? new Float64Array(0);
    for (let key = sortedLowerBound(frames, f0); key < frames.length && readNum(frames, key) <= f1; key++) {
      out.push({ row, key, frame: readNum(frames, key) });
    }
  }
  return out;
}
